/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';

class LoginMFAController {
    
    public currentUser;
    public errorDetail;
    public user = {};
    public static $inject = [
    '$state',
        'Login',
        'User',
        'toaster',
        'Orgs',
        '$scope',
        '$stateParams',
    ];

    constructor(private $state: ng.ui.IStateService,
                private Login: ILoginService,
                private User: IUserService,
                private toaster: toaster.IToasterService,
                private Org: IOrgsService,
                private $scope: ng.IScope,
                private $stateParams) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.currentUser = User.getCurrentUser();
        document.getElementById('xBtn').style.display = 'none';
        this.user['username'] = $stateParams.username;
        this.user['password'] = $stateParams.password;
    }

    public loginDo = (form: angular.IFormController) => {
        if (form.$valid) {
            this.Login.auth(this.user).then((loginResponse) => {
                this.User.loadUser().then((user) => {
                    this.$scope.$emit('$EL', 'login');

                    var currentUser: any = this.User.getCurrentUser();
                    if (currentUser.userData.user.is_superuser) {
                        this.$state.go('admin.orgs')
                        document.getElementById('xBtn').style.display = 'display';
                    } else if (currentUser.userData.subordinates.length === 0 && currentUser.userData.user.clearance === '') {
                        this.$state.go('root.employees.details', { id: currentUser.userData.id});
                    } else {
                        this.$state.go('root.home', {fromSource: 'login'});
                    }
                });
            }, (response: any) => {
                if (response.status === 403) {    
                    this.toaster.pop('error', response.data.detail);
                    this.user['mfa_code'] = '';
                }
            });
        } else {
            this.toaster.pop('warning', 'Incorrect data in the fields');
        }
    }
}

angular.module('beneple.global')
    .controller('LoginMFAController', LoginMFAController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/loginmfa.controller.ts